import { FC } from 'react';
import { Form } from '@servicetitan/design-system';
import { QueueRow } from './types';

interface RadioCellProps {
  dataItem: QueueRow;
  selectedQueue: string;
  onSelect: (queue: QueueRow) => void;
}

const RadioCell: FC<RadioCellProps> = ({
  dataItem,
  selectedQueue,
  onSelect,
}) => (
  <td>
    <Form.Radio
      checked={selectedQueue === dataItem.id}
      label=''
      onChange={() => onSelect(dataItem)}
    />
  </td>
);

export default RadioCell;
